var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8Contacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,2H4v26h20c1.105,0,2-0.895,2-2V4C26,2.895,25.105,2,24,2z M9,21c0-3.792,4-2.708,4.5-4.333v-1.083 c-0.225-0.121-0.868-0.951-0.936-1.599c-0.177-0.015-0.455-0.191-0.537-0.886c-0.044-0.373,0.131-0.583,0.237-0.649 c0,0-0.264-0.602-0.264-1.199C12,9.474,12.879,8,15,8c1.145,0,1.5,0.812,1.5,0.812c1.023,0,1.5,1.122,1.5,2.438 c0,0.656-0.264,1.199-0.264,1.199c0.106,0.066,0.281,0.276,0.237,0.649c-0.082,0.695-0.36,0.871-0.537,0.886 c-0.068,0.648-0.711,1.478-0.936,1.599v1.083C17,18.292,21,17.208,21,21H9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Contacts);
export default __webpack_public_path__ + "static/media/icons8-contacts.bdda7b7330b12a8d59ec29d9b4fc3ae3.svg";
export { ForwardRef as ReactComponent };